import api from './axios';

export const getNotifications  = ()    => api.get('/notifications/');
export const getNonLues        = ()    => api.get('/notifications/non_lues/');
export const marquerLu         = (id)  => api.post(`/notifications/${id}/marquer_lu/`);
export const toutLire          = ()    => api.post('/notifications/tout_lire/');